import script from "./Goodslist.vue?vue&type=script&setup=true&lang=js"
export * from "./Goodslist.vue?vue&type=script&setup=true&lang=js"

import "./Goodslist.vue?vue&type=style&index=0&id=ce0948f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce0948f6"]])

export default __exports__